import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'a-switcher',
  templateUrl: 'a-switcher.component.html',
  styleUrls: ['a-switcher.component.scss']
})
export class ASwitcherComponent {

  @Input() label = '';
  @Input() isDisabled = false;
  @Input() selectedValue = true;
  @Input() control = new FormControl;
  @Output() onChanged = new EventEmitter<boolean>();

  constructor() {
  }

  onChange(e: any) {
    this.control.setValue(e.target.checked);
    this.onChanged.emit(e.target.checked);
  }

}
